import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import axios from 'axios';
import ProjectCard from '../components/ProjectCard';

const Home = () => {
  const [topProjects, setTopProjects] = useState([]);

  useEffect(() => {
    axios
      .get('/scripts/getTopViewedProjects.php')
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : []; // Ensure data is an array
        setTopProjects(data);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Welcome!
        </Typography>
      </Box>

      <Typography
        variant="h4"
        component="h2"
        sx={{ mb: 4, textAlign: 'center' }}
      >
        Top 3 Most Viewed Projects
      </Typography>

      <Grid container spacing={4}>
        {topProjects.map((project) => (
          <Grid item xs={12} sm={6} md={4} key={project.project_id}>
            <ProjectCard project={project} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Home;
